import { render, staticRenderFns } from "./CustomAddRemoveListPopup.vue?vue&type=template&id=5939e128&scoped=true"
import script from "./CustomAddRemoveListPopup.vue?vue&type=script&lang=js"
export * from "./CustomAddRemoveListPopup.vue?vue&type=script&lang=js"
import style0 from "./CustomAddRemoveListPopup.vue?vue&type=style&index=0&id=5939e128&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5939e128",
  null
  
)

export default component.exports